import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

/**
 * Loading placeholder that mirrors a listing grid: renders `count` skeleton cards
 * using the parent's own grid and item classes, so the placeholder matches the real
 * layout while the data is being fetched. Purely decorative (aria-hidden); the host is
 * `display: contents` so it does not alter the surrounding layout.
 */
@Component({
  selector: 'app-grid-skeleton',
  templateUrl: './grid-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'contents' },
})
export class GridSkeletonComponent {
  count = input(8);
  gridClass = input.required<string>();
  itemClass = input.required<string>();

  protected readonly placeholders = computed(() => Array.from({ length: this.count() }, (_, index) => index));
  protected readonly itemClasses = computed(
    () =>
      `${this.itemClass()} relative overflow-hidden rounded-2xl bg-gray-light animate-pulse motion-reduce:animate-none`
  );
}
